module.exports = __webpack_public_path__ + "static/media/horizontal_com_fotos.27954d13.png";